/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { Button, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import InputAdornment from '@mui/material/InputAdornment';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  priceDetailsInputFields,
  pricingDataTableHead,
  levelDetailTableHead,
  startQtrValidation,
  getGridTwo,
  clearCellErrors,
  doQuartersOverlap,
  endQtrValidation,
  levelValidation,
} from './utils';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  getPriceDetailGrids,
  saveGridTwo,
  storeBlurState,
  storePriceDetailErrors,
  storePriceDetailsInputData,
  storeUpdatedPage,
  storePriceLevelListed,
  updateMaintainPriceLevel,
  getRebatePrograms,
} from '../store/actions';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  closeTab,
  compareQtrs,
  handleQuarterFormate,
  redirectURLLink,
  handleScrollToEvent,
  quarterTest1,
  resetDirty,
  handleExistingCommentList,
  isArr,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { SAVE_SUCCESS } from '../../../../SharedModules/AppConstants';
import PaginationBox from './PaginationBox';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { onCellFocused } from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  autoFormateDate,
  makeFormDirty,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { selectedType, dispatchCellClick } from '../../Contract/store/actions';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../Manufacturer/store/ManufacturerAction';
import { createFlag } from '../../DrugFamily/DrugFamilyDetails/store/actions';
import { getDrugFamilyDetails } from '../../DrugFamily/DrugFamilySearch/store/actions';
import * as actionType from '../../DrugFamily/DrugFamilySearch/store/actionTypes';
import { getRebatePgmDetail } from '../../RebateProgram/SearchRebate/store/actions';
import NumberFormatCustom from '../../../../SharedModules/NumberFormat/NumberFormat';

function MaintainPriceDetails() {
  const gridRef = React.useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const [fullScreenView1, setFullScreenView1] = useState(false);
  const [fullScreenView2, setFullScreenView2] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [gridParams, setGridParams] = React.useState(null);

  const [onblur, setOnblur] = useState(0);

  const rebatePriceDetails = useSelector(
    (state) => state.sharedState.PriceLevel.rebatePriceDetailsApi
  );

  const searchPageValues = useSelector(
    (state) => state.sharedState.PriceLevel.priceLevelSearchdata
  );

  const getPlanDesc = useSelector(
    (state) => state.sharedState.PriceLevel.getPlanDescApi
  );

  const priceDetailGrids = useSelector(
    (state) => state.sharedState.PriceLevel.priceDetailGrids
  );

  const storePriceLevelData = useSelector(
    (state) => state.sharedState.PriceLevel.storePriceLevelData
  );

  const updatedPage = useSelector(
    (state) => state.sharedState.PriceLevel.storeUpdatedPage
  );

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const getInputValues = useSelector(
    (state) => state.sharedState.PriceLevel.priceDetailsInputData
  );

  const getErrorMsgs = useSelector(
    (state) => state.sharedState.PriceLevel.priceDetailErrors
  );

  const overlapStateErr = useSelector(
    (state) => state.sharedState.PriceLevel.overlapStateErr
  );

  const blurPageState = useSelector(
    (state) => state.sharedState.PriceLevel.blurPageState
  );

  const commentsList = useSelector(
    (state) => state.sharedState.CommentsReducer.CommentListData
  );

  const rebatePgmView = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.pgm_res
  );

  const { counter } = getInputValues;

  const [inputValues, setInputValues] = useState(getInputValues);
  const [handlePopup, setHandlePopup] = useState('');
  const [rowValues, setRowValues] = useState([]);
  const detailsArr = rebatePriceDetails.rebateProgramLevel[0]?.getDetailsHeader;
  const drug_family_details = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.drug_family_details
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const makeItDirty = () => {
    makeFormDirty('/priceDetails', true);
  };

  // update grid data based on header details
  const updateRebatePriceDetails = async () => {
    const detailsArr =
      rebatePriceDetails.rebateProgramLevel[0]?.getDetailsHeader;
    const sortedArray = detailsArr.sort(
      (a, b) => a.familySeqNum - b.familySeqNum
    );
    const temp = sortedArray[counter];
    let qtr = '';
    const rebateList = await getRebatePrograms(searchPageValues?.planType);
    const rebateDesc =
      isArr(rebateList) &&
      rebateList.filter(
        (e) => e.rebateProgramCd === searchPageValues.rebateProgramCd
      );
    if (temp.qtrShow) {
      qtr = handleQuarterFormate(temp.qtrShow?.trim());
    }
    const obj = {
      planType: temp.planTypeCd,
      planTypeDesc:
        getPlanDesc.length > 0 ? getPlanDesc[0].shortDescription : '',
      rebatePgmCode: temp.rebateProgramCd,
      rebatePgmCodeDesc: isArr(rebateDesc) ? rebateDesc[0].shortDescr : '',
      manufactId: temp.mfgId,
      manufactName: temp.mfgName,
      quarter: qtr,
      drugFamilyName: temp.familyName,
      drugFamilyDesc: temp.familyDescr,
      successMessage: [],
    };
    setInputValues((prev) => ({
      ...prev,
      ...obj,
    }));

    const data = {
      familySeqNum: temp.familySeqNum,
      contractSeqNum: temp.contractSeqNum,
      qtr: qtr,
      contractFamilySeqNum: [temp.contractFamilySeqNum],
    };
    const result = await dispatch(getPriceDetailGrids(data));

    let grids = {};
    if (result?.payload?.rebateProgramLevel[0]) {
      grids = result?.payload?.rebateProgramLevel[0];
    }
    dispatch(
      storePriceDetailsInputData({
        ...getInputValues,
        ...obj,
        resetRowData: false,
        headerArray: detailsArr,
        currheaderArray: temp,
        getDetailsGridOne: grids.getDetailsGridOne,
        getDetailsGridTwo: grids.getDetailsGridTwo,
      })
    );
    setOnblur(0);
  };

  // change data when page changes
  React.useEffect(() => {
    updateRebatePriceDetails();
  }, [getInputValues.counter]);

  // make cancel button active if errors
  React.useEffect(() => {
    if (getErrorMsgs.length > 0) {
      makeItDirty();
      setInputValues((prev) => ({ ...prev, isCancelActive: false }));
    }
  }, [getErrorMsgs]);

  React.useEffect(() => {
    handleScrollToEvent();
  }, []);

  // UPDATE BOTH GRIDS
  React.useEffect(() => {
    if (priceDetailGrids && Object.keys(priceDetailGrids).length > 0) {
      const list = priceDetailGrids?.rebateProgramLevel[0]?.getDetailsGridTwo;
      dispatch(storePriceLevelListed(list));
      if (getInputValues.resetRowData) {
        // if new search
        const resetGrid = getGridTwo(priceDetailGrids);
        handleExistingCommentList(resetGrid, dispatch, 'allList').then(
          (res) => {
            const tempObj = res?.map((item) => {
              item.levelAmt = item.levelAmt
                ? parseFloat(item.levelAmt)?.toFixed(2)
                : parseFloat(0).toFixed(2);
              return item;
            });
            dispatch(
              storeUpdatedPage({
                ...updatedPage,
                [counter]: tempObj,
              })
            );
          }
        );
      } else if (!updatedPage[counter]) {
        const resetGrid = getGridTwo(priceDetailGrids);
        handleExistingCommentList(resetGrid, dispatch, 'allList').then(
          (res) => {
            dispatch(
              storeUpdatedPage({
                ...updatedPage,
                [counter]: res,
              })
            );
          }
        );
      }
    }
  }, [priceDetailGrids]);

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments) {
      const tempObj =
        updatedPage[counter] &&
        updatedPage[counter]?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      dispatch(storeUpdatedPage({ ...updatedPage, [counter]: tempObj }));
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
    }
  }, [commentsList]);
  //  tab highlighter Functionality
  React.useEffect(() => {
    if (getErrorMsgs && getErrorMsgs.length > 0) {
      tabHighLigther('/priceDetails', true);
    } else {
      tabHighLigther('/priceDetails', false);
    }
  }, [JSON.stringify(getErrorMsgs)]);

  // set full screen click icon button
  const handleFullScreenView = (key) => {
    if (key === 1) {
      setFullScreenView1(!fullScreenView1);
    } else {
      setFullScreenView2(!fullScreenView2);
    }
  };

  React.useEffect(() => {
    const data = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      data &&
      data.length > 0 &&
      data.filter((x) => {
        return x.navTo === '/priceDetails' && x.isFormSave;
      }).length > 0
    ) {
      const list = data.map((obj) => {
        if (obj.navTo === '/priceDetails' && obj.isFormDirty === true) {
          obj.isFormSave = false;
          handleSave(true);
        }
        return obj;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(list));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  // set max length of grid input fields
  const maxLength = (name) => {
    if (name === 'startQtr' || name === 'endQtr')
       return 6;
    if (name === 'levelId') return 10;
    return 25;
  };

  // function to update grid data
  const onCellValueChanged = (e) => {
    const storeValues = [...updatedPage[counter]];
    const name = e.column.colId;
    const { value } = e;
    if (name === 'levelId' || name === 'startQtr') {      
      storeValues[e.rowIndex] = {
        ...storeValues[e.rowIndex],
        corrLinkId: null,
        updated: true,
        [name]: value,
      };
    } else {
      storeValues[e.rowIndex] = {
        ...storeValues[e.rowIndex],
        updated: true,
        [name]: value,
      };
    }
    setInputValues((prev) => ({
      ...prev,
      rowsChanged: false,
      isCancelActive: false,
    }));
    setRowValues((prev) => ({ ...prev, [counter]: storeValues }));
    makeItDirty();
  };

  React.useEffect(() => {
    if (onblur === 0) return;
    if (Array.isArray(rowValues[counter])) {
      if (rowValues[counter]?.length > 0) {
        dispatch(
          storeUpdatedPage({ ...updatedPage, [counter]: rowValues[counter] })
        );
      }
    }
    if (!inputValues.rowsChanged) {
      dispatch(
        storePriceDetailsInputData({
          ...inputValues,
          ...getInputValues,
          rowsChanged: inputValues.rowsChanged,
          isCancelActive: inputValues.isCancelActive,
          successMessage: [],
        })
      );
    }
  }, [onblur]);

  const gridTwoOnBlur = () => {
    setOnblur((prev) => prev + 1);
  };

  // save grid popup
  const handleSave = async (close) => {
    const success = getErrorMsgs.length === 0;

    const isError = startQtrValidation(updatedPage[counter]);
    const isErrorForLevelId = levelValidation(updatedPage[counter]);

    let blurState = [...updatedPage[counter]];

    blurState = blurState.map((item) => {
      return {
        ...item,
        startQtrErr: item.startQtr === '',
        invalidStartQtrErr: !quarterTest1.test(item.startQtr),
        levelIdErr: item.levelId === '',
      };
    });

    dispatch(storeBlurState(blurState));

    let localErr = [...getErrorMsgs];
    localErr = localErr.filter((e) => e.fieldName !== 'startQtrPopup');
    localErr = localErr.filter((e) => e.fieldName !== 'levelId');
    if (isError) {
      localErr.push({
        fieldName: 'startQtrPopup',
        errorType: `startQtrRequired${updatedPage[counter]?.length}`,
        rowIndex: `${updatedPage[counter]?.length - 1}`,
        message: `${constantMessageData.START_QTR_ERR}${updatedPage[counter]?.length}.`,
      });
    }
    if (isErrorForLevelId) {
      const error = updatedPage[counter]
        .filter((item) => item.levelId === '')
        .map((item) => {
          return {
            fieldName: 'levelId',
            errorType: `required${item.rowIndex}`,
            rowIndex: item.rowIndex,
            message: `${constantMessageData.LEVEL_ID_ERR}${item.rowIndex + 1}.`,
          };
        });

      localErr = [...localErr, ...error];
    }

    dispatch(storePriceDetailErrors(localErr));
    if (!close && success && !localErr.length) {
      setHandlePopup('save');
    }
    if (close && success && !localErr.length) {
      onSaveGridTwo(close);
    }
  };

  const getObjFormat = (data) => {
    return {
      contractFamilySeqNum: data?.contractFamilySeqNum,
      levelId: data?.levelId,
      levelAmt: data?.levelAmt,
      levelPct: data?.levelPct,
      rebatePct: data?.rebatePct,
      startQtr: data?.startQtr,
      endQtr: data?.startQtr,
      lastUpdateUserId: data?.lastUpdateUserId,
      deleteRecord: 0,
    };
  };

  // save grid when confirm
  const onSaveGridTwo = async (close) => {
    const temp1 = Object.keys(updatedPage).map((keys) => {
      return updatedPage[keys]?.filter((item) => item.updated);
    });
    const allUpdatedRows = [].concat.apply([], temp1);

    const temp2 = Object.keys(getInputValues.deletedRows).map((keys) => {
      return getInputValues.deletedRows[keys].filter(
        (item) => item.startQtr !== '' && item.corrLinkId
      );
    });
    const allDeletedRows = [].concat.apply([], temp2);
    const allPages = [...allUpdatedRows, ...allDeletedRows];

    const payload = {};
    payload.updateRebatePriceLevelGridList = allUpdatedRows?.map((li) =>
      getObjFormat(li)
    );
    payload.deleteRebatePriceLevelGridList = storePriceLevelData?.filter(
      (datas, index) => {
        if (allUpdatedRows?.map((val) => val.rowIndex).includes(index)) {
          return getObjFormat(datas);
        }
      }
    );
    const data = {
      rebatePricingLevelPageVOList: [
        {
          rebatePriceLevelGridList: allPages,
        },
      ],
    };
    const result = await dispatch(saveGridTwo(data));
    if (result?.payload?.message === 'SUCESS') {
      // success message after save
      setInputValues((prev) => ({
        ...prev,
        rowsChanged: true,
        isCancelActive: true,
      }));
      dispatch(
        storePriceDetailsInputData({
          ...getInputValues,
          successMessage: [SAVE_SUCCESS],
          deletedRows: {},
          rowsChanged: true,
          isCancelActive: true,
        })
      );
      dispatch(storeUpdatedPage({}));
      // re calling grid data api after save successful
      const temp = detailsArr[counter];
      let qtr = '';
      if (temp.qtrShow) {
        qtr = handleQuarterFormate(temp.qtrShow?.trim());
      }
      const data = {
        familySeqNum: temp.familySeqNum,
        contractSeqNum: temp.contractSeqNum,
        qtr: qtr,
        contractFamilySeqNum: [temp.contractFamilySeqNum],
      };

      const resultGrid = await updateMaintainPriceLevel(payload);
      if (resultGrid?.message === 'SUCESS') {
        dispatch(getPriceDetailGrids(data));
      }
      if (close) {
        closeTab('/priceDetails', history);
      }
    }
    resetDirty('/priceDetails');
    setHandlePopup(false);
  };

  // add new row in grid
  const AddRow = (page, values, getErrorMsgs, blurPageState, cellInfo) => {
    const count = values.counter;
    if (page[count] === undefined) {
      page[count] = [];
    }
    const isError = startQtrValidation(page[count]);
    let blurState = [...page[count]];
    blurState = blurState.map((item) => {
      return {
        ...item,
        startQtrErr: item.startQtr === '' ? true : false,
      };
    });
    dispatch(storeBlurState(blurState));

    let localErr = [...getErrorMsgs];
    let checkErr = localErr.filter((e) => e.fieldName === 'startQtr');
    if (isError && !checkErr.length) {
      localErr.push({
        fieldName: `startQtr`,
        errorType: `startQtrRequired`,
        message: `${constantMessageData.START_QTR_ERR}${page[count]?.length}`,
        rowIndex: page[count]?.length,
      });
      dispatch(storePriceDetailErrors(localErr));
    }
    const newRow = {
      contractFamilySeqNum: values?.headerArray[count]?.contractFamilySeqNum,
      rowIndex: page[count]?.length,
      levelId: values.planType === 'SUPP' ? '1' : '',
      corrLinkId: null,
      startQtr: '',
      endQtr: null,
      levelAmt: '',
      levelPct: '',
      rebatePct: '',
      deleteRecord: 0,
      lastUpdateUserId: logInUser,
    };
    if (!isError && getErrorMsgs.length === 0) {
      makeItDirty();
      dispatch(
        storeUpdatedPage({
          ...page,
          [count]: [...page[count], newRow],
        })
      );
      setRowValues({ [count]: [...page[count], newRow] });
      setInputValues((prev) => ({
        ...prev,
        rowsChanged: false,
        isCancelActive: false,
      }));
      dispatch(
        storePriceDetailsInputData({
          ...values,
          rowsChanged: false,
          isCancelActive: false,
          successMessage: [],
        })
      );
    }
  };

  // cancel action to reset grid data
  const onCancel = () => {
    const resetGrid = getGridTwo(priceDetailGrids);
    setInputValues((prev) => ({
      ...prev,
      rowsChanged: true,
      isCancelActive: true,
    }));
    handleExistingCommentList(resetGrid, dispatch, 'allList').then((res) => {
      dispatch(storeUpdatedPage({ [counter]: res }));
    });
    dispatch(
      storePriceDetailsInputData({
        ...getInputValues,
        rowsChanged: true,
        isCancelActive: true,
        deletedRows: {},
        successMessage: [],
      })
    );
    setRowValues([]);
    // clear errors
    clearCellErrors(blurPageState, overlapStateErr, dispatch);
    dispatch(storePriceDetailErrors([]));
    resetDirty('/priceDetails');
    setHandlePopup(false);
  };

  // delete popup
  const DeleteRow = (cellInfo, page, getInputValues, errorArr, blurState) => {
    setHandlePopup('delete');
    setDeleteData({ cellInfo, page, getInputValues, errorArr, blurState });
  };

  // delete action to delete rows from grid
  const deleteSuccess = () => {
    const { cellInfo, page, getInputValues, errorArr, blurState } = deleteData;
    makeItDirty();
    const count = getInputValues.counter;
    const temp1 = [...page[count]];
    const temp2 = [...page[count]];
    // delete row
    const deleteRow_ = temp1
      .filter((item) => item.rowIndex !==  cellInfo?.data?.rowIndex)
      .map((item, index) => {
        return {
          ...item,
          rowIndex: index, // updating index because of mismatch after delete
        };
      });

    // store deleted rows
    let storeDeletedRows__ = [];
    storeDeletedRows__ = temp2
      .filter((item) => item.rowIndex === cellInfo.rowIndex)
      .map((item, index) => {
        return {
          ...item,
          deleteRecord: 1,
          rowIndex: index,
        };
      });

    if (Array.isArray(getInputValues.deletedRows[count])) {
      dispatch(
        storePriceDetailsInputData({
          ...getInputValues,
          successMessage: [],
          deletedRows: {
            ...getInputValues.deletedRows,
            [count]: [
              ...getInputValues.deletedRows[count],
              ...storeDeletedRows__,
            ],
          },
        })
      );
    } else {
      dispatch(
        storePriceDetailsInputData({
          ...getInputValues,
          successMessage: [],
          deletedRows: {
            ...getInputValues.deletedRows,
            [count]: storeDeletedRows__,
          },
        })
      );
    }
    dispatch(
      storeUpdatedPage({
        ...page,
        [count]: deleteRow_,
      })
    );
    setRowValues((prev) => ({ ...prev, [counter]: deleteRow_ }));
    setInputValues((prev) => ({
      ...prev,
      rowsChanged: false,
      isCancelActive: false,
    }));

    let tempArr = [...blurState];
    tempArr = tempArr.filter((e) => e.rowIndex !== cellInfo.rowIndex);
    dispatch(storeBlurState([...tempArr]));

    // update row errors
    let errors = [...errorArr];
    errors = errors.filter((item) => item.rowIndex !== cellInfo.rowIndex);
    errors = errors.filter((item) => item.errorType !== `startQtrRequired`);
    errors = errors?.filter(
      (item) => item.fieldName !== `startQtr${cellInfo.rowIndex}Invalid`
    );
    errors = errors?.filter(
      (item) => item.fieldName !== `endQtr${cellInfo.rowIndex}Invalid`
    );

    // update overlap errors
    errors = doQuartersOverlap(
      errors,
      cellInfo,
      getInputValues,
      deleteRow_,
      dispatch
    );

    dispatch(storePriceDetailErrors(errors));
    setHandlePopup(false);
  };

  // function to validate field characters length
  const onChangeGrid = (e, cellInfo) => {
    const name = cellInfo.column.colId;
    const { value } = e.target;
    const _11_6 = /^(?!$)\d{0,5}(?:\.\d{1,6})?$/; // for 11,6 chars
    const _15_6 = /^(?!$)\d{0,9}(?:\.\d{1,6})?$/; // for 15,6 chars
    if (name === 'levelAmt') {
      if (
        _15_6.test(value) ||
        value.length === 0 ||
        value.split('.')[1]?.length === 0
      ) {
        cellInfo.node.setDataValue(name, value);
      }
    } else if (name === 'levelPct' || name === 'rebatePct') {
      if (
        _11_6.test(value) ||
        value.length === 0 ||
        value.split('.')[1]?.length === 0
      ) {
        cellInfo.node.setDataValue(name, value);
      }
    } else if (name === 'startQtr' || name === 'endQtr') {
      cellInfo.node.setDataValue(name, value.toUpperCase());
    } else {
      cellInfo.node.setDataValue(name, value);
    }
  };

  // action to redirect to drug family
  React.useEffect(() => {
    if (drug_family_details) {
      const { status, message } = drug_family_details;
      if (message === 'SUCESS' && status === '001') {
        dispatch({
          type: actionType.DRUG_FAMILY_DAETAILS,
          payload: null,
        });
        if (drug_family_details?.drugFamilyVOs?.length > 1) {
          dispatch({
            type: actionType.POPUP_TABLE_DATA,
            payload: drug_family_details.drugFamilyVOs,
          });
        } else {
          dispatch(createFlag(false));

          localStorage.setItem('updatedetails', true);
          redirectURLLink(
            '/drugFamilyDetail',
            'View Drug Family Details',
            history,
            dispatch
          );
        }
      }
    }
  }, [drug_family_details]);

  // handle redirection to other pages
  const handleRedirection = async (headerData, action, gridData) => {
    const headData = headerData;
    const gridOneData = gridData.rebateProgramLevel[0].getDetailsGridOne[0];
    if (action === 'manufacturer') {
      dispatch(setSelectManufacturerData({}));
      dispatch(fetchAllManufacturerDetail(null));
      dispatch(getContactDetails(null));
      dispatch(maintainLabelerListData({}));
      dispatch(setMaintainManufacturerTab({}));
      const tempObj = {
        mfgId: headData.manufactId,
        mfgName: headData.manufactName,
        mfgTypeCd: 'C',
      };
      tempObj.updateManufacturer = true;
      const result = await dispatch(setSelectManufacturerData(tempObj));
      if (result && Object.keys(result).length > 0) {
        redirectURLLink(
          '/manufacturer-detail',
          'Maintain Manufacturer',
          history,
          dispatch
        );
      }
    }
    if (action === 'rebatePgm') {
      dispatch(
        getRebatePgmDetail({
          planType: searchPageValues.planType,
          rebateProg: searchPageValues.rebateProgramCd,
        })
      );
      setInputValues((prev) => ({ ...prev, gotoRebatePgm: true }));
    }
    if (action === 'drugFamily') {
      dispatch(
        getDrugFamilyDetails({
          familySeqNum: gridOneData.familySeqNum,
        })
      );
    }
    if (action === 'contract') {
      dispatch(dispatchCellClick(true));
      dispatch(selectedType('MF'));
      searchContractState.contractType = 'onSelect';
      searchContractState.selectedContractType = 'mfgId';
      searchContractState.selectedRowData = headData.manufactId;
      searchContractState.selectedContractId = gridOneData?.contractSeqNum;
      searchContractState.searchContractState = null;
      searchContractState.getQuarter = gridOneData?.startQtr;
      searchContractState.rebateProgramCode = headData.rebatePgmCode;
      searchContractState.planType = headData.planType;
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/createContract',
        value: 'Maintain Contract',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      history.push({
        pathname: '/createContract',
      });
    }
  };

  // redirect To rebate program screen
  React.useEffect(() => {
    if (rebatePgmView && rebatePgmView.status === '001') {
      if (inputValues.gotoRebatePgm) {
        localStorage.setItem('viewpgmdetails', 'true');
        redirectURLLink(
          '/maintainRebate',
          'Maintain Rebate Program',
          history,
          dispatch
        );
        setInputValues((prev) => ({ ...prev, gotoRebatePgm: false }));
      }
    }
  }, [rebatePgmView]);

  const onGridReady = (params) => {
    setGridParams(params);
  };

  return (
    <div className='tabs-container'>
      <Spinner load={spinnerLoader} />
      <SaveCancelPopup
        open={handlePopup === 'cancel'}
        data-testid='cancelPopup'
        title='Cancel'
        onConfim={() => {
          onCancel();
        }}
        onCancel={() => {
          setHandlePopup(false);
        }}
      />
      <SaveCancelPopup
        open={handlePopup === 'save'}
        title='Save'
        data-testid='savePopup'
        onConfim={() => onSaveGridTwo()}
        onCancel={() => setHandlePopup(false)}
      />
      <SaveCancelPopup
        open={handlePopup === 'delete'}
        title='Delete'
        data-testid='deletePopup'
        onConfim={() => deleteSuccess()}
        onCancel={() => setHandlePopup(false)}
        moduleName=''
      />
      {!fullScreenView1 && !fullScreenView2 && (
        <PaginationBox array={detailsArr} />
      )}
      {!fullScreenView1 && !fullScreenView2 && (
        <div className="mb-3">
           <CustomSeparator
            parent1='Maintain'
            parent2='Maintain Rebate Price Details'
          />
          {getErrorMsgs?.length > 0 ? (
            <DisplayErrorMessages
              errorMessages={
                getErrorMsgs?.length > 0
                  ? _.map(getErrorMsgs, (l) => l.message)
                  : []
              }
            />
          ) : null}
          <DisplaySuccessMessages
            successMessages={getInputValues.successMessage}
          />
          {/* input fields */}
          <form autoComplete='off'>
            <div className='form-wrapper'>
              <div className='mui-custom-form row row-wrap input-md'>
                {priceDetailsInputFields.map((item, index) => {
                  const isLast = priceDetailsInputFields.length - 1 === index;
                  return (
                    <div
                      className={`${
                        isLast
                          ? 'col-sm-12'
                          : 'col-3 col-md-4 col-sm-6 col-lg-4 col-xl-3 mb-3'
                      } mb-3`}
                      key={item.label}
                    >
                      {isLast && (
                        <p
                          className='no-margin tbl-help-text pt-3 pb-2 font-weight-bold'
                          htmlFor={item.label}
                        >
                          {item.label}
                        </p>
                      )}
                      <TextField
                        id={item.label}
                        label={item.label}
                        name={item.name}
                        placeholder=''
                        type={item.type}
                        disabled
                        //multiline={isLast}
                        rows={isLast ? 5 : false}
                        rowsMax={isLast ? 10 : false}
                        inputProps={{
                          maxLength: item.maxLength,
                          id: item.label,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={isLast && 'custom-textarea'}
                        value={inputValues[item.name]}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </form>

          {/* buttons */}
            <div className='flex-block justify-end pb-1'>
            <div className='btn-wrapper float-right'>
              <Button
                className='btn-success btn btn-save'
                data-testid='save-btn'
                disabled={inputValues.rowsChanged || getErrorMsgs.length > 0}
                onClick={() => handleSave(false)}
              >
                <SVGComponent iconName='Icon-awesome-save' />
                Save
              </Button>
               <Button
                className='btn btn-cancel'
                data-testid='cancel-btn'
                disabled={inputValues.isCancelActive}
                onClick={() => setHandlePopup('cancel')}
              >
                <SVGComponent iconName='Icon-cancel' />
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* GRID ONE */}
      {!fullScreenView2 && (
        <TableGridWithFeatures
          ref={gridRef}
          rowData={getInputValues.getDetailsGridOne}
          gridHeight={fullScreenView1 ? '70vh' : 400}
          fullScreenView={fullScreenView1}
          columnDefs={pricingDataTableHead}
          handleFullScreenView={false}
          handleFullScreenViewClick={() => handleFullScreenView(1)}
          enterMovesDown
          suppressCellFocus
          exportFile
          data-testid="grid-one"
          fileName="Price_Grid"
        />
      )}
      {/* GRID TWO */}
      {!fullScreenView1 && (
        <>
          <div className="manufacturer-checkbox flex-box-100 align-items-center float-left">
            <FormControlLabel
              data-testid="show-quarters-check-box"
              className="m-0 mt-2"
              control={<Checkbox color="primary" className="mr-2" />}
              label="Show All Quarters"
              value={getInputValues.showAllQuarters}
              onChange={() =>
                dispatch(
                  storePriceDetailsInputData({
                    ...inputValues,
                    showAllQuarters: !getInputValues.showAllQuarters,
                  })
                )
              }
              checked={getInputValues.showAllQuarters}
            />
            <a
              role="button"
              data-testid="addBtn"
              className={`icon-plus float-left mr-4 ${
                getErrorMsgs.length > 0 && 'frr-disable-anchor'
              } `}
              // className='icon-plus float-left mr-4 frr-disable-anchor'
              disabled={getErrorMsgs.length > 0}
              onClick={() => {
                AddRow(
                  updatedPage,
                  getInputValues,
                  getErrorMsgs,
                  blurPageState
                );
              }}
            >
              <h2 className='my-2 cursor'>Add row</h2>
            </a>
          </div>

          <div
            // id="testGrid"
            className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk"
          >
            <TableGridWithFeatures
              data-testid='price-details-grid-two'
              rowSelection='single'
              ref={gridRef}
              gridCall={onGridReady}
              rowData={
                getInputValues.showAllQuarters ? updatedPage[counter] : []
              }
              columnDefs={levelDetailTableHead}
              suppressCellFocus
              singleClickEdit
              exportFile
              onCellFocused={onCellFocused}
              fullScreenView={fullScreenView2}
              handleFullScreenView={false}
              handleFullScreenViewClick={() => handleFullScreenView()}
              gridHeight={fullScreenView2 ? '70vh' : 400}
              suppressRowClickSelection
              onCellValueChanged={onCellValueChanged}
              fileName='level-id-table'
              isScrollOn
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  const getInputValues = useSelector(
                    (state) =>
                      state.sharedState.PriceLevel.priceDetailsInputData
                  );
                  const updatedPage = useSelector(
                    (state) => state.sharedState.PriceLevel.storeUpdatedPage
                  );
                  const priceDetailGrids = useSelector(
                    (state) => state.sharedState.PriceLevel.priceDetailGrids
                  );
                  const getErrorMsgs = useSelector(
                    (state) => state.sharedState.PriceLevel.priceDetailErrors
                  );
                  const overlapStateErr = useSelector(
                    (state) => state.sharedState.PriceLevel.overlapStateErr
                  );
                  const blurPageState = useSelector(
                    (state) => state.sharedState.PriceLevel.blurPageState
                  );
                  return (
                    <div
                      className='tdCell icon-btn-group d-flex'
                      data-testid='action-column'
                    >
                      {showComments ? (
                        <Button
                          onClick={() => {
                            if (cellInfo.data.corrLinkId) {
                              setCorrLinkId(cellInfo.data.corrLinkId);
                              setShowComments(true);
                            }
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              if (cellInfo.data.corrLinkId) {
                                setCorrLinkId(cellInfo.data.corrLinkId);
                                setShowComments(true);
                              }
                            }
                          }}
                          data-testid='comments-btn'
                          aria-label='Comment'
                          className={`th-ic comment-ic ${parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                            1
                            ? 'frr-enabled-comment-btn'
                            : 'frr-disabled-comment-btn'
                            }`}
                          variant='text'
                        >
                          {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                            1 ? (
                            <img alt='' src={CommentVisibleIcon} />
                          ) : (
                            <img alt='' src={CommentIcon} />
                          )}
                        </Button>
                      ) : (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
                        >
                                        <Button
                            onClick={() => {
                              if (cellInfo.data.corrLinkId) {
                                setCorrLinkId(cellInfo.data.corrLinkId);
                                setShowComments(true);
                              }
                            }}
                            tabIndex={'0'}
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                if (cellInfo.data.corrLinkId) {
                                  setCorrLinkId(cellInfo.data.corrLinkId);
                                  setShowComments(true);
                                }
                              }
                            }}
                            data-testid='comments-btn'
                            disabled={cellInfo.data.corrLinkId === null}
                            aria-label='Comment'
                            className={`th-ic comment-ic ${parseInt(
                              cellInfo.data.ccCommentsExist,
                              [0, 1]
                            ) === 1
                              ? 'frr-enabled-comment-btn'
                              : 'frr-disabled-comment-btn'
                              }`}
                            variant='text'
                          >
                            {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                              1 ? (
                              <img alt='' src={CommentVisibleIcon} />
                            ) : (
                              <img alt='' src={CommentIcon} />
                            )}
                          </Button>
                        </OverlayTrigger>
                      )}
                       <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='add-tooltip'>Add</Tooltip>}
                      >
                        <Button
                          className='float-left'
                          data-testid='add-new-log-check'
                          aria-label='Add new log check'
                          variant='text'
                          disabled={getErrorMsgs?.length > 0}
                          onClick={() =>
                            AddRow(
                              updatedPage,
                              getInputValues,
                              getErrorMsgs,
                              blurPageState,
                              cellInfo
                            )
                          }
                        >
                          <SVGComponent iconName="Icon-addCircle" />
                        </Button>
                      </OverlayTrigger>
                      <Dropdown className="icon-dropdown-container">
                        <Dropdown.Toggle
                          className="icon-dropdown export_wrap"
                          aria-label="export"
                        >
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="action-tooltip">Actions</Tooltip>
                            }
                          >
                            <SVGComponent iconName="Icon-export1" />
                          </OverlayTrigger>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="export_dropdown">
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              handleRedirection(
                                getInputValues,
                                'contract',
                                priceDetailGrids
                              )
                            }
                          >
                            Go to Contract
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              handleRedirection(
                                getInputValues,
                                'manufacturer',
                                priceDetailGrids
                              )
                            }
                          >
                            Go to Manufacturer
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              handleRedirection(
                                cellInfo,
                                'rebatePgm',
                                priceDetailGrids
                              )
                            }
                          >
                            Go to Rebate Program
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              handleRedirection(
                                cellInfo,
                                'drugFamily',
                                priceDetailGrids
                              )
                            }
                          >
                            Go to Drug Family
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                        <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}
                      >
                        <Button
                          aria-label='Delete'
                          data-testid='deleteBtn'
                          className='th-ic trash-blue'
                          variant='text'
                          onClick={() =>
                            DeleteRow(
                              cellInfo,
                              updatedPage,
                              getInputValues,
                              getErrorMsgs,
                              blurPageState
                            )
                          }
                        >
                          <SVGComponent iconName='Icon-delete' />
                        </Button>
                      </OverlayTrigger>
                    </div>
                  );
                },
                TextBoxRender: (cellInfo) => {
                  const { rowIndex } = cellInfo;
                  const updatedPage = useSelector(
                    (state) => state.sharedState.PriceLevel.storeUpdatedPage
                  );
                  const getInputValues = useSelector(
                    (state) =>
                      state.sharedState.PriceLevel.priceDetailsInputData
                  );
                  const blurPageState = useSelector(
                    (state) => state.sharedState.PriceLevel.blurPageState
                  );
                  const overlapStateErr = useSelector(
                    (state) => state.sharedState.PriceLevel.overlapStateErr
                  );
                  const count = getInputValues.counter;
                  const getErrorMsgs = useSelector(
                    (state) => state.sharedState.PriceLevel.priceDetailErrors
                  );
                  const { colId } = cellInfo.column;
                  const isNegative = Math.sign(cellInfo.data?.levelAmt);

                  const handleOnBlur = (e) => {
                    let storeValues = [...blurPageState];
                    const { value } = e.target;
                    let localErr = [...getErrorMsgs];
                    if (blurPageState[rowIndex]) {
                      storeValues = [...blurPageState];
                    } else {
                      const temp = updatedPage[count]?.map((item) => {
                        return {
                          ...item,
                          startQtrErr: false,
                          invalidStartQtrErr: false,
                          endQtrErr: false,
                          rangeInvalidErr: false,
                          levelIdErr: false,
                        };
                      });
                      storeValues = [...temp];
                    }

                    // when value isn't empty
                    if (colId === 'startQtr' || colId === 'endQtr') {
                      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
                        if (quarterTest1.test(value)) {
                          if (colId === 'startQtr') {
                            storeValues[rowIndex].startQtrErr = false;
                            storeValues[rowIndex].invalidStartQtrErr = false;
                            const isErr1 = storeValues.map(
                              (e) => e.startQtrErr
                            );
                            if (!isErr1.includes(true)) {
                              localErr = localErr?.filter(
                                (item) =>
                                  item.errorType !==
                                  `startQtrRequired${rowIndex}`
                              );
                            }
                          }

                          if (colId === 'endQtr') {
                            storeValues[rowIndex].endQtrErr = false;
                          }
                          dispatch(storeBlurState(storeValues));
                          // localErr = localErr?.filter(
                          //   (item) => item.rowIndex != rowIndex
                          // );
                          localErr = localErr?.filter(
                            (item) =>
                              item.fieldName !== `${colId}${rowIndex}Invalid`
                          );
                          // localErr = localErr?.filter(
                          //   (item) =>
                          //     item.errorType !== `invalidFormat${rowIndex}`
                          //     // item.field === `${colId}${rowIndex}Invalid`
                          // );
                          if (
                            cellInfo.data?.endQtr !== '' &&
                            cellInfo.data?.endQtr !== null &&
                            colId === 'startQtr'
                          ) {
                            if (compareQtrs(value, cellInfo.data?.endQtr)) {
                              storeValues[rowIndex].rangeInvalidErr = true;
                              localErr.push({
                                errorType: 'rangeInvalid',
                                rowIndex,
                                message: `${
                                  constantMessageData.END_QTR_GRATER_START_QTR_ERR
                                } ${rowIndex + 1}`,
                              });
                              dispatch(storeBlurState(storeValues));
                            } else {
                              storeValues[rowIndex].rangeInvalidErr = false;
                              dispatch(storeBlurState(storeValues));
                            }
                          } else if (
                            cellInfo.data?.startQtr !== '' &&
                            colId === 'endQtr'
                          ) {
                            if (compareQtrs(cellInfo.data?.startQtr, value)) {
                              storeValues[rowIndex].rangeInvalidErr = true;
                              localErr.push({
                                errorType: 'rangeInvalid',
                                rowIndex,
                                message: `${
                                  constantMessageData.END_QTR_GRATER_START_QTR_ERR
                                } ${rowIndex + 1}`,
                              });
                              dispatch(storeBlurState(storeValues));
                            } else {
                              localErr = localErr.filter(
                                (e) => e.errorType !== 'rangeInvalid'
                              );
                              storeValues[rowIndex].rangeInvalidErr = false;
                              dispatch(storeBlurState(storeValues));
                            }
                          }
                        } else {
                          if (colId === 'startQtr') {
                            storeValues[rowIndex].invalidStartQtrErr = true;
                            storeValues[rowIndex].startQtrErr = false;
                            const isErr1 = storeValues.map(
                              (e) => e.startQtrErr
                            );
                            if (!isErr1.includes(true)) {
                              localErr = localErr?.filter(
                                (item) =>
                                  item.errorType !==
                                  `startQtrRequired${rowIndex}`
                              );
                            }
                            localErr = localErr?.filter(
                              (item) =>
                                item.fieldName !== `${colId}${rowIndex}Invalid`
                            );
                            localErr.push({
                              fieldName: `${colId}${rowIndex}Invalid`,
                              errorType: `invalidFormat${rowIndex}`,
                              message: `${
                                constantMessageData.INVALID_START_QTR_ERR
                              }${rowIndex + 1}.`,
                              // rowIndex,
                            });
                          }
                          if (colId === 'endQtr') {
                            storeValues[rowIndex].endQtrErr = true;
                            localErr = localErr.filter(
                              (e) =>
                                e.errorType !== `startQtrRequired${rowIndex}`
                            );
                            localErr = localErr?.filter(
                              (item) =>
                                item.fieldName !== `${colId}${rowIndex}Invalid`
                            );
                            localErr.push({
                              fieldName: `${colId}${rowIndex}Invalid`,
                              errorType: `invalidFormat${rowIndex}`,
                              message: `${
                                constantMessageData.INVALID_END_QTR_ERR
                              }${rowIndex + 1}`,
                              // rowIndex,
                            });
                          }
                          dispatch(storeBlurState(storeValues));
                        }
                      }
                      // when value empty
                      else {
                        if (colId === 'endQtr') {
                          value = autoFormateDate(value?.toUpperCase())
                          storeValues[rowIndex].endQtrErr = false;
                          localErr = localErr.filter(
                            (e) => e.fieldName !== `endQtr${rowIndex}`
                          );
                          localErr = localErr.filter(
                            (e) => e.fieldName !== `${colId}${rowIndex}Invalid`
                          );
                          dispatch(storeBlurState(storeValues));
                        }
                        if (colId === 'startQtr') {
                          storeValues[rowIndex].startQtrErr = true;
                          localErr = localErr.filter(
                            (e) => e.errorType !== `startQtrRequired${rowIndex}`
                          );
                          localErr = localErr.filter(
                            (e) => e.fieldName !== `${colId}${rowIndex}Invalid`
                          );
                          localErr = localErr.filter(
                            (e) => e.fieldName !== 'startQtrPopup'
                          );
                          localErr.push({
                            fieldName: 'startQtr',
                            errorType: `startQtrRequired${rowIndex}`,
                            message: `${constantMessageData.START_QTR_ERR}${
                              rowIndex + 1
                            }.`,
                            rowIndex,
                          });
                          dispatch(storeBlurState(storeValues));
                        }
                      }
                    }

                    // QUARTER OVERLAP LOGIC

                    let updatedArr = [...updatedPage[count]];
                    updatedArr = updatedArr.map((item, index) => {
                      if (index === rowIndex) {
                        return {
                          ...item,
                          ...cellInfo.data,
                        };
                      }
                      return item;
                    });

                    if (
                      colId === 'rebatePct' ||
                      colId === 'startQtr' ||
                      colId === 'endQtr'
                    ) {
                      localErr = doQuartersOverlap(
                        localErr,
                        cellInfo,
                        getInputValues,
                        updatedArr,
                        dispatch
                      );
                    }

                    // LEVEL ID VALDATION
                    if (colId === 'levelId') {
                      if (_.isEmpty(value)) {
                        storeValues[rowIndex].levelIdErr = true;
                        localErr = localErr.filter(
                          (e) => e.rowIndex !== rowIndex
                        );
                        localErr.push({
                          fieldName: 'levelId',
                          errorType: `required${rowIndex}`,
                          rowIndex: rowIndex,
                          message: `${constantMessageData.LEVEL_ID_ERR}${
                            rowIndex + 1
                          }.`,
                        });
                      } else {
                        storeValues[rowIndex].levelIdErr = false;
                        localErr = localErr.filter(
                          (e) => e.rowIndex !== rowIndex
                        );
                      }
                      dispatch(storeBlurState(storeValues));
                    }

                    // dispatch only unique objects (errors)
                    const unique = localErr.filter(
                      (value, index, self) =>
                        index ===
                        self.findIndex(
                          (t) =>
                            t.errorType[rowIndex] === value.errorType[rowIndex]
                        )
                    );

                    dispatch(storePriceDetailErrors(localErr));

                    // clear success msg when error exist
                    if (localErr.length > 0) {
                      dispatch(
                        storePriceDetailsInputData({
                          ...getInputValues,
                          successMessage: [],
                        })
                      );
                    }
                  };

                  const disableInput = (key) => {
                    if (key === 'levelId' || key === 'levelAmt') {
                      if (
                        getInputValues.planType === 'COMM' &&
                        getInputValues?.getDetailsGridOne[0]?.volumeCalcMethodCd
                      ) {
                        return false;
                      }
                      return true;
                    } else if (key === 'levelPct') {
                      if (
                        getInputValues.planType === 'COMM' &&
                        getInputValues?.getDetailsGridOne[0]
                          ?.mktShareCalcMethodCd
                      ) {
                        return false;
                      }
                      return true;
                    } else {
                      return false;
                    }
                  };
                  const RedColor='#a81f00'

                  return (
                    <div className='form-wrapper frr-remove-formClt-mt-label'>
                      {getInputValues.planType === 'SUPP' &&
                      colId === 'levelAmt' &&
                      isNegative == '-1' ? (
                        <div
                          style={{ color: RedColor }}
                        >{`(${cellInfo?.data?.levelAmt
                          ?.toString()
                          ?.replace('-', '')
                          .trim()})`}</div>
                      ) : (
                        <div>
                          <TextField
                            style={{ marginTop: '5px', color: RedColor }}
                            id={colId + cellInfo.rowIndex}
                            data-testid={colId}
                            name={colId}
                            fullWidth
                            required
                            placeholder=""
                            inputProps={{
                              maxLength: maxLength(cellInfo.column.colId),
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={
                              colId === 'levelAmt'
                                ? {
                                    inputComponent: NumberFormatCustom,
                                    startAdornment: (
                                      <InputAdornment
                                        position='start'
                                        className='prefix-symbol'
                                      >
                                        $
                                      </InputAdornment>
                                    ),
                                  }
                                : null
                            }
                            className={
                              colId === 'startQtr'
                                ? (blurPageState[rowIndex] &&
                                    blurPageState[rowIndex]?.startQtrErr) ||
                                  (blurPageState[rowIndex] &&
                                    blurPageState[rowIndex]
                                      ?.invalidStartQtrErr) ||
                                  (overlapStateErr[rowIndex] &&
                                    overlapStateErr[rowIndex]?.startQtrOverlap)
                                  ? 'td-active-cell tBill-validate'
                                  : 'frr-display-hidden-label'
                                : colId === 'endQtr'
                                ? (blurPageState[rowIndex] &&
                                    blurPageState[rowIndex]?.endQtrErr) ||
                                  (blurPageState[rowIndex] &&
                                    blurPageState[rowIndex]?.rangeInvalidErr)
                                  ? 'td-active-cell tBill-validate'
                                  : 'frr-display-hidden-label'
                                : colId === 'levelId'
                                ? blurPageState[rowIndex] &&
                                  blurPageState[rowIndex]?.levelIdErr
                                  ? 'td-active-cell tBill-validate'
                                  : 'frr-display-hidden-label'
                                : 'frr-display-hidden-label'
                            }
                            disabled={!!disableInput(colId)}
                            value={cellInfo.value}
                            onChange={(e) => onChangeGrid(e, cellInfo)}
                            onBlur={(e) => {
                              gridTwoOnBlur();
                              const arr = [
                                'levelId',
                                'rebatePct',
                                'startQtr',
                                'endQtr',
                              ];
                              if (arr?.includes(colId)) {
                                handleOnBlur(e);
                              }
                            }}
                          />
                        </div>
                      )}
                    </div>
                  );
                },
              }}
            />
          </div>
        </>
      )}

      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName='REBATE_PRICING_LEVEL'
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={null}
        />
      ) : null}
    </div>
  );
}

export default MaintainPriceDetails;
